if (!customElements.get('tabbed-collections')) {
  class TabbedCollections extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-tab-target]');
        if (!clickedElement) return;
        this.switchTab(clickedElement);
      });

      this.addEventListener('keydown', (e) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;

        const tabs = [...this.querySelectorAll('[data-tab-target]')];
        const activeTab = this.querySelector('[data-tab-target].active');
        const currentIndex = tabs.indexOf(activeTab);

        let newIndex;
        if (e.key === 'ArrowLeft') {
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'ArrowRight') {
          newIndex = (currentIndex + 1) % tabs.length;
        }

        this.switchTab(tabs[newIndex]);
        tabs[newIndex].focus();
      });
    }

    switchTab(tabElement) {
      const id = tabElement.dataset.tabTarget;
      [...this.querySelectorAll('[data-tab-container]')].forEach((el) => {
        if (el.dataset.tabContainer === id) {
          el.style.display = null;
          return;
        }
        el.style.display = 'none';
      });
      [...this.querySelectorAll('[data-tab-target]')].forEach((el) => {
        el.classList.remove('active');
        el.setAttribute('aria-current', false);
        el.setAttribute('tabindex', '-1');
      });
      tabElement.classList.add('active');
      tabElement.setAttribute('aria-current', true);
      tabElement.setAttribute('tabindex', '0');
    }
  }

  customElements.define('tabbed-collections', TabbedCollections);
}
